import { authService } from '../../../services/auth.ts';
import { OrganizationService } from '../../../services/organization.ts';
import { MetricsService } from '../../../services/metrics.ts';
import { DomainService } from '../../../services/domain.ts';
import { AlertService } from '../../../services/alert.ts';
import '../../../components/library/ui/app-icon.ts';

export class AppOverview extends HTMLElement {
  private _profile: any = null;
  private _isInitialized = false;

  constructor() {
    super();
  }

  async connectedCallback() {
    if (this._isInitialized) return;
    this._isInitialized = true;
    
    await this.loadData();
    this.render();
  }

  private async loadData() {
    try {
      this._profile = await authService.getProfile();
    } catch (e) {
      console.error('AppOverview: Failed to load profile', e);
    }
  }

  render() {
    const name = this._profile?.name || this._profile?.email?.split('@')[0] || 'Operator';
    
    this.innerHTML = `
      <div style="padding: 24px; font-family: var(--font-mono); font-size: 1rem; color: white;">
        Welcome back, ${name}.
      </div>
    `;
  }
}

if (!customElements.get('app-overview')) {
  customElements.define('app-overview', AppOverview);
}
